// Group Model
cv.SiteGroup = Backbone.Model.extend({
	defaults : {
		title : '',
		expanded : true,
		ids : []
	},

	initialize: function(){
		console.log('Site Group model initialized.');
	}
});

cv.SiteGroups = Backbone.Collection.extend({
	initialize: function(){
		console.log('Site Group collection initialized.');
	},

	model: cv.SiteGroup
});
